import { auditLogsReducer } from './slice'

export default auditLogsReducer
